import { mobileCheck } from "src/helpers/mixins"
import whatsapp from "../../assets/images/whatsapp.png"

const Whatsapp = () => {


  return (
    <div onClick={() => visitWhatsapp()} >
      <img
        src={whatsapp}
        className="cursor-pointer w-11 h-11 whatsapp-fixed"
        alt="whatsapp"
      />
    </div >
  )
}

export const visitWhatsapp = (text?:string) => {
  //const isMobile = navigator?.userAgentData?.mobile
  let route = `https://web.whatsapp.com/send?phone=+573209158591&text=${text ? text : 'Hola, vengo de www.isfcambios.com'}` 
  
  if (mobileCheck()) {
    route = `https://wa.me/+573209158591?text=${text ? text : 'Hola, vengo de www.isfcambios.com'}`
  }
    // @ts-ignore 
    window?.open(route, "_blank").focus();
}


export const visitWhatsappExpert = (text?:string) => {
  //const isMobile = navigator?.userAgentData?.mobile
  let route = `https://web.whatsapp.com/send?phone=+573213246132&text=${text ? text : 'Quiero la asesoria de un experto.'}` 
  
  if (mobileCheck()) {
    route = `https://wa.me/+573213246132?text=${text ? text : 'Quiero la asesoria de un experto.'}`
  }
    // @ts-ignore 
    window?.open(route, "_blank").focus();
}



export const alternativeVisitWhatsapp = (text?:string) => {
  //const isMobile = navigator?.userAgentData?.mobile
  let route = `https://web.whatsapp.com/send?phone=+573209158591&text=${text ? text : 'Hola, estoy interesado en Recarga Dolares P2P Deriv.'}` 
  
  if (mobileCheck()) {
    route = `https://wa.me/+573209158591?text=${text ? text : 'Hola, estoy interesado en Recarga Dolares P2P Deriv.'}`
  }
    // @ts-ignore 
    window?.open(route, "_blank").focus();
}
export default Whatsapp